import axios from 'axios';

// Create an instance of Axios
const axiosInstance = axios.create({
  baseURL: window.APP_CONFIG.baseapi,//'https://api.dsccou.sebs.asia/api/', // Your base URL
  timeout: 10000, // Optional: Set a timeout if needed
});

// Set up the request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add authorization token or other modifications to the request headers
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    console.log('Request intercepted:', config);
    return config;
  },
  (error) => {
    // Handle request errors
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Set up the response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Response intercepted:', response);
    return response; // Return the response if successful
  },
  (error) => {
    // Handle response errors
    if (error.response) {
      console.error('Response error:', error.response);
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    return Promise.reject(error); // Reject the error
  }
);

// Export the axios instance so it can be imported and used in other files
export default axiosInstance;
